import { render, staticRenderFns } from "./actionsList.vue?vue&type=template&id=5aba8671&scoped=true"
import script from "./actionsList.vue?vue&type=script&lang=js"
export * from "./actionsList.vue?vue&type=script&lang=js"
import style0 from "./actionsList.vue?vue&type=style&index=0&id=5aba8671&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aba8671",
  null
  
)

export default component.exports